import { atom } from "jotai";

export type ActiveButtonType = "color" | "zap" | "app" | "actor";

export const floatingToolbarActiveButtonAtom = atom<ActiveButtonType | null>(
  null,
);

floatingToolbarActiveButtonAtom.debugLabel = "floatingToolbarActiveButtonAtom";
